export default "__VITE_ASSET__BXNJ5bEd__"